import React, { useRef, forwardRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

// Move this outside the component
const ReactQuillNoSSR = forwardRef((props, ref) => (
  <ReactQuill {...props} ref={ref} />
));

const Editor = ({ value, onChange }) => {
  const quillRef = useRef(null);

  return (
    <ReactQuillNoSSR
      ref={quillRef}
      theme="snow"
      value={value}
      onChange={onChange}
    />
  );
};

export default Editor;
